import React, { useRef } from "react";

import { observer } from "mobx-react-lite";

import { IconPlus } from "@synthesis/shared-icons";
import { Button, setSnack } from "@synthesis/shared-ui";

import { useUploadProgress } from "../../../file-uploader/file-uploader";
import { useStores } from "../../../store";

const AddFile = observer(({ disabledRight, isModal, closeModal }: { disabledRight?: boolean; isModal?: boolean; closeModal?: () => void }) => {
  const { generalStore } = useStores();
  const ref = useRef<HTMLInputElement | null>(null);
  const { startUpload } = useUploadProgress();

  const handleClick = () => {
    if (ref.current) {
      ref.current.value = "";
      ref.current.click();
    }
  };

  const onSelectedFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const MAX_SIZE_SIZE = 2147483648; // 2GB
    closeModal?.();

    const filesArray: File[] = Array.from(event.target.files ?? []);
    const totalSize = filesArray.reduce((acc, file) => acc + file.size, 0);

    if (totalSize > MAX_SIZE_SIZE) {
      setSnack({
        messageType: "error",
        title: "Максимальный суммарный размер файлов не должен превышать 2 ГБ",
      });
      return;
    }

    if (generalStore.activeTab === "docs") {
      const nonPdfFiles = filesArray.filter((file: File) => !file.name.toLowerCase().endsWith(".pdf"));
      if (nonPdfFiles.length > 0) {
        setSnack({
          messageType: "error",
          title: "Можно загружать только файлы формата PDF",
        });
        return;
      }
      startUpload(filesArray, "pdf");
      return;
    }

    if (generalStore.activeTab === "models") {
      const nonIfcFiles = filesArray.filter((file: File) => !file.name.toLowerCase().endsWith(".ifc"));
      if (nonIfcFiles.length > 0) {
        setSnack({
          messageType: "error",
          title: "Можно загружать только файл формата ifc",
        });
        return;
      }
      startUpload(filesArray, "ifc");
    }
  };

  return (
    <>
      <input data-cy="addFile-input-projectDocks" type="file" className="hidden" ref={ref} multiple onChange={onSelectedFile} />
      <Button
        size="sm"
        leftIcon={<IconPlus data-cy="addFile-iconPlus-fileSystem" className="size-5" />}
        data-cy="addFile-button-projectDocks"
        disabled={disabledRight}
        theme={isModal ? "primary" : "secondary"}
        onClick={handleClick}
      >
        Добавить файл
      </Button>
    </>
  );
});

export default AddFile;
